import { render } from "./accept-parcel.vue?vue&type=template&id=32f32ec0"
import script from "./accept-parcel.vue?vue&type=script&lang=js"
export * from "./accept-parcel.vue?vue&type=script&lang=js"

import "./accept-parcel.vue?vue&type=style&index=0&id=32f32ec0&lang=css"

import exportComponent from "C:\\active-project\\NeginPostClub\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__